import { createSelector } from '@reduxjs/toolkit';
import { detailsPageSelector } from '@yme/selectors/index';
export const getFeaturesIDs = (key) => createSelector([detailsPageSelector.getAttribute(key)], (features) => features);
